// Contenuti modificabili: sostituisci i valori null con gli URL reali quando sono pronti.
export const EVENT_START = new Date("2026-11-25T20:30:00+01:00");
export const EVENT_TIME = "20:30 – 22:30";
export const SEATS_LEFT = null;

export const MEDIA = {
  heroYoutubeId: "Y_QqhIG2ZBA",
  heroVideo: null,
  welcomeVideo: null,
  superGlowPdf: null,
  speakers: { valentina: null, renata: null },
  results: {
    "Spider Lift": { before: null, after: null },
    "Doll Skin": { before: null, after: null },
    "Double Lift": { before: null, after: null },
    "Miracle Mask 2.0": { before: null, after: null },
    "BodyOne 369": { before: null, after: null },
    "Nuovo protocollo": { before: null, after: null },
  },
};

export const LOGO = "/assets/logo-skinlovers.png";
